export default __webpack_public_path__ + "static/media/about2.7627ba1b.png";